import React, { useState } from 'react';
import ReportingFilterParams from '../ReportingFilterParams';
import GraphLegend from '../GraphLegend';
import PlanningDetailsItemService from '../../../Services/PlanningDetailsItemService';
import PlanningDetailsForReportingItem from '../../../Domain/PlanningDetailsForReportingItem';
import ExportReport from './ExportReport';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';

function Reporting() {
  const [searchItem, setSearchItem] = useState(() => new ReportingFilterParams());
  // The report covers a period the user has to choose, so nothing is fetched until they ask for
  // it: the grid stays empty until the first search, as it did before.
  const [cleared, setCleared] = useState(true);

  const getReport = (orderBy, orderDirection, pageNumber, numberOfElements, filter) =>
    PlanningDetailsItemService.GetPlanningDetailsItemsWithFilter(
      ReportingFilterParams.PrepareForBackend(filter),
      orderBy,
      orderDirection
    );

  const startSearch = (newSearchItem) => {
    setCleared(false);
    setSearchItem(newSearchItem);
  };

  const exportExcel = () => {
    ExportReport.SaveAsExcel(ReportingFilterParams.PrepareForBackend(searchItem), 'PlanningFWReport');
  };

  return (
    <div className='contentwrapper'>
      <TabOfDataTable
        type={PlanningDetailsForReportingItem}
        serviceFunction={getReport}
        convertDBItemsFunction={PlanningDetailsItemService.ConvertDBPlanningDetailsForReportingItems}
        searchItem={searchItem}
        cleared={cleared}
        orderBy='PlanningDetailId'
        orderDirection={OrderDirectionsEnum.Asc}
        showSearchStrip={true}
        resizableColumns={true}
        openFilterOnMount={true}
        searchParamsType={ReportingFilterParams}
        clickOnStartSearch={startSearch}
        singleSearchLine={true}
        singleSearchLinePlaceholder='Search client, service, country, office...'
        isExportExcelDisabled={false}
        clickOnExportExcel={exportExcel}
        excelExportTooltipMessage='Export the report to Excel'
        showPagination={false}
        popupEnabled={false}
        enableUrlPush={false}
        itemTypeName='planning details'
        thereIsNoSuchRowMessage={`Set a filter and click "View on Screen" to show the report.`}
        errorCode='RP55'
      />
      <GraphLegend />
    </div>
  );
}

export default Reporting;
